import { Colors, typographyStyle } from '@revenuemarket/cds';

import { css } from '~libs/emotion';

export const SectionPressed = css`
  &:active {
    background-color: ${Colors.grayOpacity04};
    transform: scale(0.99);
    transition: transform 0.1s ease;
  }
`;

export const DefaultTabStyle = css`
  &&& .ant-tabs-tab {
    padding: 8px;
  }

  &&& .ant-tabs-tab > div {
    color: ${Colors.gray700};
    ${typographyStyle['16_400']}
  }
  &&& .ant-tabs-ink-bar {
    background-color: ${Colors.gray900};
  }
  &&& .ant-tabs-tab-active > div {
    color: ${Colors.gray900} !important;
    font-weight: 400;
  }
  &&& .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 4px;
  }

  &&& .ant-tabs-content,
  &&& .ant-tabs-tabpane {
    height: 100%;
  }
`;
